import { useContext } from "react";
import { Button } from "iuvity-ui-components";
import { AppContext } from "../../context";
import noEraseIcon from "../../assets/icon_noerrase.svg";

interface ActionProps {
  enableDelete?: boolean;
  enableEdit?: boolean;
  onDelete?: Function;
  onDetail?: Function;
  onDetailAndEdit?: Function,
  viewButtonEdit?: boolean;
  viewButtonDelete?: boolean;
  onEdit?: Function;
  auxButtons?: Array<{
    label: string;
    icon?: string;
    color?: string;
    function: Function;
    disabled?: boolean;
    order?: string;
    showButton?: boolean;
  }>;
  visibleObject?: {
    CREATE: boolean,
    READ: boolean,
    UPDATE: boolean,
    REMOVE: boolean,
  },
  colorEdit?: string,
}

export const Actions: React.FC<ActionProps> = ({
  enableDelete,
  enableEdit = true,
  onDelete = () => { },
  onDetail,
  onDetailAndEdit,
  viewButtonEdit = true,
  viewButtonDelete = true,
  colorEdit = 'var(--warningColor)',
  onEdit = () => { },
  auxButtons,
  visibleObject = {
    CREATE: true,
    READ: true,
    UPDATE: true,
    REMOVE: true,
  }
}) => {
  const { t } = useContext(AppContext);
  const { UPDATE, REMOVE  } = visibleObject;

  return (
    <div className="flex justify-content-center gap-2 general-actions-datatable">
      {onDetail && (
        <Button
          icon="iu"
          className="p-button-rounded p-button-success p-button-outlined act-btn"
          aria-label="Detail"
          tooltip={t("TableActions.detailLabel")}
          tooltipOptions={{ position: "bottom" }}
          variant="p-button"
          onClick={() => onDetail()}
          style={{
            color: "var(--successColor)",
          }}
        >
          <i className="iu iu-icon-detail act-btn detail" />
        </Button>
      )}
      {onDetailAndEdit && (
        <Button
          icon="iu "
          className="p-button-rounded p-button-success p-button-outlined act-btn"
          aria-label="Detail"
          tooltip={t("TableActions.detailLabel")}
          tooltipOptions={{ position: "bottom" }}
          variant="p-button"
          onClick={() => onDetailAndEdit()}
          style={{
            color: "var(--successColor)",
          }}
        >
          <i className="iu iu-icon-detail act-btn detail" />
        </Button>
      )}
      {(viewButtonEdit && enableEdit && onEdit && UPDATE) && (
        <Button
          icon="iu"
          className="p-button-rounded p-button-info p-button-outlined act-btn"
          aria-label="Edit"
          tooltip={t("TableActions.editLabel")}
          tooltipOptions={{ position: "bottom" }}
          variant="p-button"
          onClick={() => onEdit()}
          style={{
            color: colorEdit ? colorEdit : "var(--warningColor)",
          }}
        >
          <i className="iu iu-icon-edit act-btn edit" />
        </Button>
      )}
      {(onDelete && viewButtonDelete && REMOVE) && (
        <Button
          icon="iu"
          className={`p-button-rounded p-button-outlined act-btn ${enableDelete ? 'p-button-danger' : ''}`}
          aria-label="Delete"
          tooltip={enableDelete ? t("TableActions.deleteLabel") : t("TableActions.noDeleteLabel")}
          tooltipOptions={{ position: "bottom" }}
          variant="p-button"
          onClick={enableDelete ? () => onDelete() : ()=>{}}
          style={{
            color: !enableDelete
              ? "var(--errorColorTint60)"
              : "var(--errorColor)",
          }}
        >
          {
            enableDelete
              ? <i className="iu iu-icon-delete act-btn error" />
              : <img
              alt='no-erase-icon'
              src={noEraseIcon}
          />
          }
        </Button>
      )}
      {auxButtons &&
        auxButtons.map((btn, idx) => {
          const showButton = btn?.hasOwnProperty('showButton') ? btn.showButton : true;
          return showButton
            ? (<Button
                key={`btn-${idx}`}
                icon="iu"
                className="p-button-rounded p-button-danger p-button-outlined act-btn"
                aria-label="Delete"
                tooltip={btn.label}
                tooltipOptions={{ position: "bottom" }}
                variant="p-button"
                onClick={() => btn.function()}
                disabled={btn.disabled || false}
                style={{
                  color: btn.color,
                  order: btn?.order || undefined,
                }}
              >
                <i className={`iu ${btn.icon} act-btn`} />
              </Button>)
            : null
        })}
    </div>
  );
};
